import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, IconButton, Typography } from '@material-ui/core'
import { ChevronUp as ChevronUpIcon } from 'react-feather'

import PermissionMatrixHeaderChipCell from '../PermissionMatrixHeaderChipCell'
import { columnShape } from '../../propTypes'
import useStyles from './styles'

const PermissionMatrixHeader = ({
  icon,
  title,
  columns,
  collapsible,
  expanded,
  onToggle,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.header}>
      <Box className={classes.iconBox}>{icon}</Box>
      <Typography className={classes.title}>{title}</Typography>
      <Box className={classes.chips}>
        {columns.map((column) => (
          <PermissionMatrixHeaderChipCell key={column.id} column={column} />
        ))}
      </Box>
      <IconButton
        className={clsx(classes.expand, {
          [classes.expandOpen]: expanded,
          [classes.expandClosed]: !expanded,
          [classes.expandHidden]: !collapsible,
        })}
        onClick={onToggle}
        disabled={!collapsible}
        aria-label="Expandir ou recolher"
      >
        <ChevronUpIcon size={20} />
      </IconButton>
    </Box>
  )
}

PermissionMatrixHeader.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(columnShape).isRequired,
  collapsible: PropTypes.bool,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
}

export default PermissionMatrixHeader
